module.exports = __webpack_public_path__ + "img/room1.aa94cd55.jpg";